<template>
    <div>


        <span v-loading.fullscreen.lock="fullScreenLoading">
  
        <el-dialog
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            :append-to-body="true"
            title=""
            width="80%"
            top="8vh"
            
        >
            <div v-if="audioShow" class="center" style="width:100%;height:75vh;">
                <div id="amazingaudioplayer-1" style="display:block;position:relative;width:100%;max-width:500px;height:auto;margin:0px auto 0px;">
                    <ul class="amazingaudioplayer-audios" style="display:none;">
                        <li data-artist="" :data-title="playData.dataTitle" data-album="" data-info="" :data-image="playData.dataImageUrl" data-duration="0">
                            <div class="amazingaudioplayer-source" :data-src="playData.dataSrc" data-type="audio/mpeg" ></div>
                        </li>
                    </ul>
                </div>
            </div>

        </el-dialog>
        </span>
    </div>
      

  </template>


  <script>

  export default {
    name: 'AudioShow',
    components: {
        'remote-css': {
            render(createElement) {            
              return createElement('link', { attrs: { rel: 'stylesheet', href: this.href }});
            },
            props: {
            href: { type: String, required: true },
            },
        },
        'remote-js': {
            render(createElement) {
              return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});            
            },
            props: {
            src: { type: String, required: true },
            },
        }
    },
    props: {
      firstList: {
        type: Object,
        default: () => {
          return {}
        }
      },
      course: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    inject: [],
    data() {
        return {
            dialogVisible: false,
            fullScreenLoading: false,
            source_prefix:process.env.VUE_APP_UPYUN_PATH,
            audioList: [
                'http://txh-cdn.96qbhy.com/20180817175211dtC1vE3z.mp3',
                'http://txh-cdn.96qbhy.com/20181106105737sOcozMqw.mp3'
            ],
            playData:{
                dataTitle:"",
                dataImageUrl:"",
                dataSrc:"",
            },
            audioShow:false,
            myPlayer:{}
        }
    },
    watch: {
  
    },
    created() { },
    methods: {
        show(data) {
            this.audioShow = true
  
            this.playData.dataTitle = data.sources_name
            this.playData.dataImageUrl = this.source_prefix + data.cover_url
            this.playData.dataSrc = this.source_prefix + data.sources_url
       
            this.dialogVisible = true
            var a = 1
            setTimeout(
                function() {
                    
                    jQuery(document).ready(function(){
                      
                    var scripts = document.getElementsByTagName("script");

                    var jsFolder = "";

                    for (var i= 0; i< scripts.length; i++)
                    {

                        if( scripts[i].src && scripts[i].src.match(/initaudioplayer-1\.js/i))

                            jsFolder = scripts[i].src.substr(0, scripts[i].src.lastIndexOf("/") + 1);

                    }

                    var a = jQuery("#amazingaudioplayer-1").amazingaudioplayer({

                        jsfolder:jsFolder,

                        skinsfoldername:"",

                        tracklistarrowimage:"tracklistarrow-48-16-1.png",

                        timeformatlive:"%CURRENT% / LIVE",

                        volumeimagewidth:24,

                        barbackgroundimage:"",

                        tracklistarrowimageheight:16,

                        showtime:false,

                        titleinbarwidth:80,

                        showprogress:true,

                        random:false,

                        titleformat:"%TITLE%",

                        height:800,

                        loopimage:"loop-24-24-2.png",

                        prevnextimage:"prevnext-48-48-1.png",

                        showinfo:true,

                        imageheight:300,

                        skin:"LightBox",

                        responsive:true,

                        loopimagewidth:24,

                        showstop:false,

                        prevnextimageheight:48,

                        infoformat:"%ARTIST% %ALBUM%<br />%INFO%",

                        tracklistbackgroundimage:"",

                        showloading:false,

                        forcefirefoxflash:false,

                        tracklistscroll:true,

                        preloadaudio:true,

                        showvolumebar:true,

                        imagefullwidth:true,

                        width:800,

                        showimage:true,

                        showloop:false,

                        volumeimage:"volume-24-24-2.png",

                        playpauseimagewidth:48,

                        loopimageheight:24,

                        tracklistitemformat:"<div class='amazingaudioplayer-item-id'>%ID%</div><div class='amazingaudioplayer-item-info'>%DURATION%</div><div class='amazingaudioplayer-item-title'>%TITLE%</div>",

                        prevnextimagewidth:48,

                        titleinbarwidthmode:"fixed",

                        forceflash:false,

                        tracklistarrowimagewidth:48,

                        playpauseimageheight:48,

                        showbackgroundimage:false,

                        stopimage:"stop-48-48-0.png",

                        showvolume:true,

                        playpauseimage:"playpause-48-48-1.png",

                        forcehtml5:false,

                        showprevnext:false,

                        backgroundimage:"",

                        loadingformat:"Loading...",

                        progressheight:8,

                        showtracklistbackgroundimage:false,

                        titleinbarscroll:true,

                        showtitle:true,

                        defaultvolume:100,

                        showtitleinbar:false,

                        heightmode:"fixed",

                        titleinbarformat:"%TITLE%",

                        showtracklist:false,

                        stopimageheight:48,

                        volumeimageheight:24,

                        stopimagewidth:48,

                        volumebarheight:80,

                        noncontinous:false,

                        stopotherplayers:true,

                        showbarbackgroundimage:false,

                        volumebarpadding:8,

                        imagewidth:800,

                        timeformat:"%CURRENT% / %DURATION%",

                        autoplay:false,

                        fullwidth:false,

                        loop:1,

                        tracklistitem:10

                    });
                    
                });
                
            }, 50)
            
            
            this.$forceUpdate()
    
        },
        onBeforePlay(next) {
                next() // 开始播放
        },
        handleClose()
        {
            this.dialogVisible = false
            this.audioShow = false
            g_audioplayer.amazingPlayer.stopAudio()
     
      
     
        },

    },
    mounted() {
    },
  }
  </script>
  
  
  <style>

  </style>
  